import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { of } from 'rxjs';
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
import { AuthService } from '../../core/auth/auth.service';
import * as fromStore from '../../store';

export const globalGuard: CanActivateFn = () => {
  return checkSalesYearsLoaded().pipe(
    switchMap(() => of(true)),
    catchError(() => of(false))
  );
};

const checkSalesYearsLoaded = (): Observable<boolean> => {
  const authService = inject(AuthService);
  const store = inject(Store<fromStore.State>);

  return authService.isAuthenticated$.pipe(
    // only pass when user is authenticated
    filter((isAuthenticated) => isAuthenticated),
    // perform necessary loads
    switchMap(() => checkStore(store))
  );
};

const checkStore = (store: Store<fromStore.State>): Observable<boolean> => {
  return store.select(fromStore.getSalesYearsLoaded).pipe(
    tap((loaded) => {
      if (!loaded) {
        store.dispatch(fromStore.loadSalesYears());
      }
    }),
    filter((loaded) => loaded),
    take(1)
  );
};
